import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { familiesForGoal, popularNames } from "../lib/goals";

export const GoalTile = ({ goal, families, index = 0 }) => {
  const Icon = goal.icon;
  const inGoal = familiesForGoal(families, goal);
  const popular = popularNames(families, goal);
  const supplies = goal.slug === "research-supplies";
  const noun = inGoal.length === 1 ? (supplies ? "supply" : "peptide") : (supplies ? "supplies" : "peptides");
  return (
    <Link
      to={`/shop/${goal.slug}`}
      data-testid={`goal-tile-${goal.slug}`}
      className={`group relative overflow-hidden rounded-2xl border bg-gradient-to-br ${goal.gradient} p-5 sm:p-6 flex gap-4 sm:gap-5 min-h-[232px] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_50px_-24px_rgba(26,26,26,0.35)] animate-fade-in`}
      style={{ borderColor: goal.border, animationDelay: `${Math.min(index, 6) * 70}ms` }}
    >
      <div className="flex flex-col flex-1 min-w-0">
        <div className="flex items-center gap-2.5">
          <span className="w-9 h-9 rounded-full bg-white/80 backdrop-blur flex items-center justify-center shrink-0" style={{ color: goal.iconColor }}>
            <Icon className="w-[18px] h-[18px]" />
          </span>
          <span
            className="text-[11px] tracking-[0.15em] uppercase font-semibold px-2.5 py-1 rounded-none"
            style={{ background: goal.badgeBg, color: goal.badgeText }}
            data-testid={`goal-tile-count-${goal.slug}`}
          >
            {inGoal.length} {noun}
          </span>
        </div>
        <div className="mt-auto pt-8">
          <h3 className="font-product text-lg sm:text-xl font-semibold tracking-wide text-[#1A1A1A]">{goal.name}</h3>
          <p className="text-sm text-[#6E675F] mt-1.5 leading-relaxed">{goal.tagline}</p>
          {popular.length > 0 && (
            <p className="text-xs text-[#1A1A1A]/70 mt-3 leading-relaxed" data-testid={`goal-tile-popular-${goal.slug}`}>
              <span className="font-semibold">Popular:</span> {popular.join(", ")}{inGoal.length > popular.length ? " & more" : ""}
            </p>
          )}
          <span className="inline-flex items-center gap-2 mt-5 text-xs tracking-[0.18em] uppercase font-semibold text-[#1A1A1A] group-hover:gap-3 transition-all duration-300">
            View products <ArrowRight className="w-4 h-4" />
          </span>
        </div>
      </div>
      <div className="shrink-0 self-center">
        <div
          className="w-24 h-24 sm:w-32 sm:h-32 rounded-xl bg-white shadow-[0_10px_30px_-14px_rgba(26,26,26,0.35)] ring-1 ring-black/5 overflow-hidden transition-transform duration-500 group-hover:-rotate-2 group-hover:scale-[1.03]"
          data-testid={`goal-tile-image-${goal.slug}`}
        >
          <img src={goal.image} alt={`${goal.name} research vial`} loading="lazy" className="w-full h-full object-cover" />
        </div>
      </div>
    </Link>
  );
};
